<template>
  <!--音频专辑添加  -->
  <div class="topicAdd">
    <div class="add_box">
      <el-form
        :model="AddList"
        :rules="toAdRule"
        label-position="right"
        label-width="200px"
        ref="ruleForm"
        style="width: 90%;margin:20px auto; "
      >
        <el-row>
          <el-form-item label="选择作者" prop="authorId">
            <el-select placeholder="请选择" v-model="AddList.authorId">
              <el-option
                v-for="item in author"
                :key="item.id"
                :label="item.nickName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="专辑名字" prop="name">
              <el-input placeholder="请输入内容" v-model="AddList.name" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="提供者" prop="producer">
              <el-input placeholder="请输入内容" v-model="AddList.producer" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <el-form-item label="专辑描述" prop="description">
              <el-input
                type="textarea"
                :rows="10"
                placeholder="请输入内容"
                v-model="AddList.description"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="专辑封面图" prop="frontCoverUrl" ref="frontCoverUrl">
            <el-upload
              class="avatar-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="TopicUpt"
              :on-success="TopicSuccess"
              :before-upload="beforeUpload"
            >
              <img v-if="AddList.frontCoverUrl" :src="AddList.frontCoverUrl" class="avatar" />
              <!-- <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
                style="marginTop:5px;font-size: 50px;"
              ></i> -->

               <i
                :class="imgLoad ? 'el-icon-loading' : 'el-icon-plus avatar-uploader-icon'"
                style="marginTop:10px;font-size: 50px;marginLeft:6px"
                v-else
              ></i>
            </el-upload>
          </el-form-item>
        </el-row>
        <el-row>
          <el-button style="margin-left: 200px" type="primary" @click="submitAdd('ruleForm')" v-if="menuPerm('audio:add')">保存</el-button>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
      var valiIcon = (rule, value, callback) => {
      // 图片验证
     
      if (this.AddList.frontCoverUrl == "") {
        callback(new Error("不能为空"));
      } else {
        callback();
      }
    };
    return {
      imgLoad:false,//加载load

      AudioUptImg: [], //图片上传
      //添加的参数：
      AddList: {
        authorId: "", //作者 id
        name: "", //专辑名字
        description: "", //描述
        frontCoverUrl: "", //封面图
        producer: "" //出品方
      },
      toAdRule: {
        authorId: [
          { required: true, message: "内容不能为空", trigger: "change" }
        ],
        name: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        description: [
          { required: true, message: "内容不能为空", trigger: "blur" }
        ],
        producer: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        frontCoverUrl:[{ required: true, validator: valiIcon, trigger: "blur" }],
      },
      author: "" //作者
    };
  },
  methods: {
    //作者：
    getAuthor() {
      this.getAxios("/manager/list/userInfo", {
        managerId: localStorage.getItem("userId")
      }).then(res => {
        if (res.success == true) {
          this.author = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push('/')
        }else if(res.success==false){
          this.$message.error(res.message);
        }
      });
    },
    //转base64
    getBase64(file) {
      return new Promise(function(resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file.raw);
        reader.onload = function() {
          imgResult = reader.result;
        };
        reader.onerror = function(error) {
          reject(error);
        };
        reader.onloadend = function() {
          resolve(imgResult);
        };
      });
    },
    //上传图片限制
    beforeUpload(file, fileList) {
      return new Promise(resolve => {
        // 图片压缩
        let reader = new FileReader(),
          img = new Image();
        reader.readAsDataURL(file);
        reader.onload = function(e) {
          img.src = e.target.result;
        };

        img.onload = function() {
          let canvas = document.createElement("canvas");
          let context = canvas.getContext("2d");
          let width = "100";
          let height = "100";
          let originWidth = width;
          let originHeight = height;

          canvas.width = originWidth;
          canvas.height = originHeight;

          context.clearRect(0, 0, originWidth, originHeight);
          context.drawImage(img, 0, 0, originWidth, originHeight);

          canvas.toBlob(
            blob => {
              let imgFile = new File([blob], file.name, { type: file.type }); // 将blob对象转化为图片文件
              resolve(imgFile);
            },
            file.type,
            0.2
          ); // file压缩的图片类型
        };
      });
    },
    //图片上传：
    TopicUpt(file, fileList) {
      this.imgLoad = true;
      this.AudioUptImg = [];
      this.getBase64(file).then(resBase64 => {
        this.AudioUptImg.push(resBase64);
        if (this.AudioUptImg) {
          this.postAxios("/file/uploadBase64", {
            fileList: this.AudioUptImg
          }).then(res => {
            if (res.success == true) {
              this.$message.success("上传成功");
              this.AddList.frontCoverUrl = res.content[0]; //接口url参数
              this.AudioUptImg = [];
               this.$refs.frontCoverUrl.clearValidate();
            } else if (res.success == false) {
              this.$message.error(res.message);
            }

      
            if (!res.success && res.statusCode == "401") {
            this.$message.error(res.message);
            this.$router.push('/')
            }
          });
        }
      });
    },
    //提交成功：
    TopicSuccess(res, file) {
      this.$refs.uptImg.clearValidate();
    },
    //新增专题：
    submitAdd(formName) {

      this.$refs[formName].validate(valid => {
        if (valid) {
          this.postAxios("/audio/album/insert", {
            authorId: this.AddList.authorId, //作者 id
            name: this.AddList.name, //专辑名字
            description: this.AddList.description, //描述
            frontCoverUrl: this.AddList.frontCoverUrl, //封面图
            producer: this.AddList.producer //出品方
          }).then(res => {
            if (res.success == true) {
              this.$router.push({ path: "/audio" });
              this.$message.success("添加成功！");
            } else if (res.success == false) {
              if (res.message == "frontCoverUrl 不能为空") {
                this.$message.error("专辑封面图不能为空");
              } else {
                this.$message.error(res.message);
              }
            } else if (
              !res.success && res.statusCode == "401" 
            ) {
              this.$message.error(res.message);
              this.$router.push('/')
            }
          });
        } else {
          return false;
        }
      });
    }
  },
  created() {
    this.getAuthor(); //作者
  }
};
</script>
<style scoped lang="less">
.topicAdd {
  width: 100%;
  height: 100%;
  .add_box {
    width: 95%;
    height: 100%;
    margin: 0 auto;
    /deep/ .el-upload {
      width: 200px;
      height: auto;
      display: inline-block;
      text-align: center;
      cursor: pointer;
      outline: 0;
      border: 2px dashed #eee;
      display: table-cell;
      vertical-align: middle;
      text-align: center;

      img {
        width: 100%;
        height: auto;
      }
    }
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
    }

   /deep/ .el-upload-list--picture-card {
    margin: 0;
    display: inline;
    vertical-align: top;
    // display: table-cell;
    vertical-align: middle;
    text-align: center;
}
  }
}
</style>